import React, { useState } from "react";
import PartnerPageHeader from "../components/PartnerPageHeader";
import DeployWizardForm from "../components/DeployWizardForm";
import PartnerAiEmployeeRequestsList from "../components/PartnerAiEmployeeRequestsList";

const PartnerDeploy = () => {
  const [requestsRefreshKey, setRequestsRefreshKey] = useState(0);

  return (
    <div data-testid="partner-deploy">
      <PartnerPageHeader
        tag="Deployment wizard"
        title="Deploy client"
        titleAccent="Digital Assistant"
        subtitle="Provision a new client tenant under your agency brand. Wholesale billing charges your saved card automatically. No checkout redirect."
      />
      <DeployWizardForm
        onRequestSubmitted={() => setRequestsRefreshKey((key) => key + 1)}
      />
      <div className="mt-10">
        <PartnerAiEmployeeRequestsList refreshKey={requestsRefreshKey} />
      </div>
    </div>
  );
};

export default PartnerDeploy;
